import type { ColorStops, Rgb } from '@/core/utils';
import { UNIT_SYSTEMS, type UnitSystem } from '@/features/units';

/** Red (low margin) → blue (high margin). */
export const MARGIN_COLORS: readonly Rgb[] = [
  [215, 25, 28],
  [253, 174, 97],
  [255, 255, 191],
  [171, 217, 233],
  [44, 123, 182],
];

/** Cells at the max-radius edge: more may be reachable beyond it. */
export const MAX_REACHED_COLOR: Rgb = [161, 66, 245];

/** Legend step, in the unit system's height unit, so labels are round numbers. */
const LEGEND_STEP: Record<UnitSystem, number> = { metric: 300, imperial: 1000 };

/** Colour stops in metres of margin. */
export const marginColorStops = (system: UnitSystem): ColorStops =>
  MARGIN_COLORS.map((c, i) => [i * LEGEND_STEP[system] * UNIT_SYSTEMS[system].height.metres, c] as const);
